import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../Components/InnerLayout/Headerbar";
import UserInterface from "../Components/InnerLayout/UserInterface";
import { useInView } from "react-intersection-observer";
const Clipboard = (params) => {
  const [ref1, inView1, entry1] = useInView({ threshold: 0.5 });
  const [ref2, inView2, entry2] = useInView({ threshold: 0.5 });
  const [ref3, inView3, entry3] = useInView({ threshold: 0.5 });

  // scrolling Logic
  function scrollToDiv(divId) {
    const targetParent = document.querySelector(".scroll-sec");
    const targetParentTop = targetParent.getClientRects()[0].top;
    const targetDiv = document.getElementById(divId);
    console.log(targetDiv);
    const targetDivTop = targetDiv.getClientRects()[0].top;

    const difference = targetDivTop - targetParentTop + targetParent.scrollTop;
    targetParent.scroll({ left: 0, top: difference, behavior: "smooth" });

    // OR we can do it by using scrollIntoView()
    // targetDiv.scrollIntoView({
    //   behavior: "smooth",
    // });
  }
  return (
    <UserInterface>
      <div className="no-sidebar row mb-0 mx-0">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Daily Clipboard</h4>
                    <div class="row justify-content-between align-items-center mx-0">
                      <div class="col-md-6 col-12 px-0">
                        <div class="search-box mt-0 w-100">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="calendr cel-product mt-3">
                  <a href="/productions/index/date:2022-05-15">
                    <i class="iconSprites arrow-left"></i>
                  </a>{" "}
                  <div class="text">
                    <span>16</span>
                    <small>
                      Monday
                      <br />
                      May&nbsp;2022
                    </small>
                  </div>
                  <a id="cal_open" href="#_">
                    <i class="iconSprites cal-icon"></i>
                  </a>
                  <a href="#_" class="r-arrow">
                    <i class="iconSprites arrow-right"></i>
                  </a>
                </div>

                <div class="clipboard-left-content fixed-pos">
                  <ul class="steps">
                    <li
                      onClick={() => scrollToDiv("clipboard-morning")}
                      id="clipboard-morning-tab"
                      className={`${inView1 ? "active" : " "}`}
                    >
                      <a>Morning</a>{" "}
                    </li>
                    <li
                      onClick={() => scrollToDiv("clipboard-afternoon")}
                      id="clipboard-afternoon-tab"
                      className={`${inView2 ? "active" : " "}`}
                    >
                      <a>Afternoon</a>{" "}
                    </li>
                    <li
                      onClick={() => scrollToDiv("clipboard-night")}
                      id="clipboard-night-tab"
                      className={`${inView3 ? "active" : " "}`}
                    >
                      <a>Night</a>{" "}
                    </li>
                  </ul>

                  <div className="scroll-sec">
                    <div
                      id="clipboard-morning"
                      style={{ display: "flow-root" }}
                      ref={ref1}
                    >
                      <div class="row-fluid scroll-change full_div">
                        <div class="col-12 main-grey-container pt-4">
                          <h3>Morning Shift</h3>
                          <div id="DIV_0_1" className="col-12">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Notepad</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Notepad
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_2" className="col-12">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Checklist</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <span class="status checklist_status m-0">
                                    <span>Status:</span> Complete
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_3" className="col-12">
                            <div class="eventlist eventDynamic notepad-part">
                              <h5 class="col-4 mb-0">Events</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Events
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_4" className="col-12">
                            <div class="eventlist">
                              <h5>Count</h5>
                              <span class="count_status"></span>
                              <h6>This Morning's Register Count</h6>
                              <div class="three-columns">
                                <div class="first-column col-md-9 col-lg-6">
                                  <dl>
                                    <dt>Expected Cash Sales</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][expected_cash_sales]"
                                        placeholder="Manual Input or Fed in from POS"
                                        class="expected_cash_sales required number currency"
                                        type="text"
                                        id="CountPerUserExpectedCashSales"
                                      />
                                    </dd>
                                  </dl>
                                  <dl>
                                    <dt>Actual Count</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][actual_count]"
                                        placeholder="Add Cash Amount"
                                        class="actual_count number currency"
                                        type="text"
                                        id="CountPerUserActualCount"
                                      />
                                    </dd>
                                  </dl>
                                </div>
                                <div class="second-column col-md-3 col-md-3">
                                  <h3 class="break_amount_show">$0.00</h3>
                                  <p>Unexplained Break Amount</p>
                                </div>
                              </div>
                              <div class="btns float-end my-3">
                                <input type="submit" class="btn" value="Save" />
                              </div>
                            </div>
                          </div>

                          <div class="shift-box ptb"></div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="clipboard-afternoon"
                      style={{ display: "flow-root" }}
                      ref={ref2}
                    >
                      <div class="row-fluid scroll-change full_div">
                        <div class="col-12 main-grey-container pt-4">
                          <h3>Afternoon Shift</h3>
                          <div id="DIV_0_1">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Notepad</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Notepad
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_2" className="col-12">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Checklist</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <span class="status checklist_status m-0">
                                    <span>Status:</span> Complete
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_3" className="col-12">
                            <div class="eventlist eventDynamic notepad-part">
                              <h5 class="col-4 mb-0">Events</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Events
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_4" className="col-12">
                            <div class="eventlist">
                              <h5>Count</h5>
                              <span class="count_status"></span>
                              <div class="clear"></div>
                              <h6>This Afternoon's Register Count</h6>
                              <div class="three-columns">
                                <div class="first-column col-md-9 col-lg-6">
                                  <dl>
                                    <dt>Expected Cash Sales</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][expected_cash_sales]"
                                        placeholder="Manual Input or Fed in from POS"
                                        class="expected_cash_sales required number currency"
                                        type="text"
                                        id="CountPerUserExpectedCashSales"
                                      />
                                    </dd>
                                  </dl>
                                  <dl>
                                    <dt>Actual Count</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][actual_count]"
                                        placeholder="Add Cash Amount"
                                        class="actual_count number currency"
                                        type="text"
                                        id="CountPerUserActualCount"
                                      />
                                    </dd>
                                  </dl>
                                </div>
                                <div class="second-column col-md-3 col-md-3">
                                  <h3 class="break_amount_show">$0.00</h3>
                                  <p>Unexplained Break Amount</p>
                                </div>
                              </div>
                              <div class="btns float-end my-3">
                                <input type="submit" class="btn" value="Save" />
                              </div>
                            </div>
                          </div>

                          <div class="shift-box ptb"></div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="clipboard-night"
                      style={{ display: "flow-root" }}
                      ref={ref3}
                    >
                      <div class="row-fluid scroll-change full_div">
                        <div class="col-12 main-grey-container pt-4">
                          <h3>Night Shift</h3>
                          <div id="DIV_0_1">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Notepad</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Notepad
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_2" className="col-12">
                            <div class="notepad-part">
                              <h5 class="col-4 mb-0">Checklist</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <span class="status checklist_status m-0">
                                    <span>Status:</span> Complete
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_3" className="col-12">
                            <div class="eventlist eventDynamic notepad-part">
                              <h5 class="col-4 mb-0">Events</h5>

                              <div class="col-md-4 align-right">
                                <div class="field text-right">
                                  <button
                                    class="btn green-btn-revert add-plus mx-0"
                                    type="button"
                                  >
                                    <i class="i-icon"> </i> Add Events
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="DIV_0_4" className="col-12">
                            <div class="eventlist">
                              <h5>Count</h5>
                              <span class="count_status"></span>
                              <h6>This Night's Register Count</h6>
                              <div class="three-columns">
                                <div class="first-column col-md-9 col-lg-6">
                                  <dl>
                                    <dt>Expected Cash Sales</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][expected_cash_sales]"
                                        placeholder="Manual Input or Fed in from POS"
                                        class="expected_cash_sales required number currency"
                                        type="text"
                                        id="CountPerUserExpectedCashSales"
                                      />
                                    </dd>
                                  </dl>
                                  <dl>
                                    <dt>Actual Count</dt>
                                    <dd>
                                      <input
                                        name="data[CountPerUser][actual_count]"
                                        placeholder="Add Cash Amount"
                                        class="actual_count number currency"
                                        type="text"
                                        id="CountPerUserActualCount"
                                      />
                                    </dd>
                                  </dl>
                                </div>
                                <div class="second-column col-md-3 col-md-3">
                                  <h3 class="break_amount_show">$0.00</h3>
                                  <p>Unexplained Break Amount</p>
                                </div>
                              </div>
                              <div class="btns float-end my-3">
                                <input type="submit" class="btn" value="Save" />
                              </div>
                            </div>
                          </div>

                          <div class="shift-box ptb"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* scrololign tabs */}
      {/* <div className="">
          <ul className="">
            <li
              onClick={() => scrollToDiv("clipboard-morning")}
              id="AccDetail_li"
              className={`${inView1 ? "active" : " "}`}
            >
              <a id="AccDetail_dayTime_a">
                Account <br />
                Details
              </a>
            </li>
            <li
              onClick={() => scrollToDiv("clipboard-afternoon")}
              id="Address_li"
              className={`${inView2 ? "active" : " "}`}
            >
              <a id="Address_dayTime_a">Address</a>
            </li>
            <li
              onClick={() => scrollToDiv("clipboard-night")}
              id="FinSettings_li"
              className={`${inView3 ? "active" : " "}`}
            >
              <a id="FinSettings_dayTime_a">
                Finance <br />
                Settings
              </a>
            </li>
          </ul>
        </div> */}
      {/* scrolling sections */}
    </UserInterface>
  );
};
export default Clipboard;
